import React from 'react';
import './SocialFloatingButton.css';

const SocialFloatingButton = () => {
  return (
    <>
      {/* Phone Call Button - Left Side */}
      <div className="social-fab-container left-container">
        <div className="fab-wrapper left-align">
          <a
            href="tel:+919370832534"
            className="social-fab phone-single"
            aria-label="Call Now"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
            </svg>
          </a>
          {/* <span className="fab-text left-text">Call Now</span> */}
        </div>
      </div>

      {/* WhatsApp Button - Right Side */}
      <div className="social-fab-container right-container">
        <div className="fab-wrapper right-align">
          {/* <span className="fab-text right-text">WhatsApp</span> */}
          <a
            href="https://wa.me/919370832534"
            target="_blank"
            rel="noopener noreferrer"
            className="social-fab whatsapp-single"
            aria-label="Chat on WhatsApp"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.922-3.556 7.922-7.93 0-2.125-4.06-6.254-2.32-6.607zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.965 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.834-.308-1.588-.983-.587-.525-.983-1.175-1.098-1.373-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.608-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.944-.05-.083-.182-.133-.38-.232z" />
            </svg>
          </a>
        </div>
      </div>
    </>
  );
};

export default SocialFloatingButton;
